module.exports = __webpack_public_path__ + "img/grey.30c073e1.svg";